import { TopBar } from "@/components/TopBar";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Hero } from "@/components/home/Hero";
import { WhatWeTeach } from "@/components/home/WhatWeTeach";
import { EducationFirst } from "@/components/home/EducationFirst";
import { ProgramsPreview } from "@/components/home/ProgramsPreview";
import { HowItWorks } from "@/components/home/HowItWorks";
import { WhoWeHelp } from "@/components/home/WhoWeHelp";
import { FundingEducation } from "@/components/home/FundingEducation";
import { EducationCenter } from "@/components/home/EducationCenter";
import { Disclaimer } from "@/components/home/Disclaimer";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function HomePage() {
  usePageMeta(
    "J11 Consulting | Credit Education & Funding Readiness",
    "J11 Consulting provides credit education, financial literacy coaching, business credit education and funding readiness mentorship for individuals and entrepreneurs."
  );

  return (
    <div data-testid="home-page">
      <TopBar />
      <Navbar />
      <main>
        <Hero />
        <WhatWeTeach />
        <EducationFirst />
        <ProgramsPreview />
        <HowItWorks />
        <WhoWeHelp />
        <FundingEducation />
        <EducationCenter />
        <Disclaimer />
      </main>
      <Footer />
    </div>
  );
}
